import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    confirmMigrationTitle: {
        id: 'migration.modal.confirm_migration.title',
        defaultMessage: 'Confirmation of migration',
    },
    confirmMigrationSubtitle: {
        id: 'migration.modal.confirm_migration.subtitle',
        defaultMessage: 'Please confirm your Freewallet account and balances migration to {brokerName}',
    },
    confirmButtonText: {
        id: 'migration.modal.confirm_button.text',
        defaultMessage: 'Confirm',
    },
    signOutButtonText: {
        id: 'migration.modal.sign_out_button.text',
        defaultMessage: 'Sign out',
    },
    confirmMigrationError: {
        id: 'migration.modal.confirm_migrations_error.text',
        defaultMessage: 'Something went wrong',
    },
})
